import React, { Component, PureComponent } from 'react';
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'
import Base from './Config'
import { Modal,ButtonToolbar,Button } from 'react-bootstrap';
import { TextArea } from 'semantic-ui-react';
import WaveLoading from 'react-loadingg/lib/WaveLoading';
// import 'bootstrap/dist/css/bootstrap.min.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import {
    Link
  } from "react-router-dom";


// import { CSVLink, CSVDownload } from "react-csv";


class FilterModal extends React.PureComponent {
    constructor(){
        super()
        this.state = {
            keyword:"all",
            days:"",
        }
    }
    
    submitForm=()=>{
        
        // console.log('state ',this.state);
        
        // let data = []
        // data.push({'orderid':this.props.id,'details':this.state})
        this.props.makefilter(this.state.keyword,this.state.days)
        this.props.onHide()
        this.clear()
        
    }
    clear(){
        this.setState({
            keyword:"",
            days:"",
        })
    }

    handleChange = (e)=> {
        this.setState({
            [e.target.name]:e.target.value
        });
    }

    render() {

        
        return (
            <Modal
            {...this.props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                   Advanced Filtering
        </Modal.Title>
            </Modal.Header>
            <Modal.Body >

                <div>
                Users  :
                </div>
                <div>
                    {/* <Dropdown options={category} onChange={this._onSelect} value={defaultOption} placeholder="Select an option" />; */}
                    <div className="form-group">
                        <select name="keyword" value={this.state.category} onChange={this.handleChange} className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed',paddingLeft:18}}  >
                            <option value='all' >All</option>
                            <option value='expired' >Expired</option>
                            <option value='ex_soon' >Expire soon</option>
                        </select>
                    </div>
                </div>
                {this.state.keyword=="ex_soon"&&
                <div className="form-group">
                Expire after : <input name="days" type="number" onChange={this.handleChange} className=" form"/> days (optional, by default 30)
                </div>
                }
                
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.submitForm}>Done</Button>
            </Modal.Footer>
        </Modal>
        )
    }
}

class Items extends PureComponent {
    constructor(){
        super()
        this.state={
            open:false,
            reasonmodal:false,
        }
    }
    toggle() {
        this.setState({
          open: !this.state.open
        });
      }
    callActivateParentFunction=()=>{
        // console.log('id ',this.props.quotation.id);
        this.props.ManageUsers(this.props.quotation.id,'actv')
    }

    callDeactivateParentFunction=(reason)=>{
        // console.log('id ',this.props.quotation.id);
        // console.log("dact reason ",reason)
        this.props.ManageUsers(this.props.quotation.id,'dactv',reason)
    }

    render() {
        // const {Activate,Deactivate} =this.props
        let data = this.props.data
        // console.log('data ',data);
        var date = new Date(data.ex_date)
        var today = new Date();
        
        // To calculate the time difference of two dates 
        var Difference_In_Time = today.getTime() - date.getTime(); 
  
        // To calculate the no. of days between two dates 
        var Difference_In_Days =  parseInt(Difference_In_Time / (1000 * 3600 * 24)) 

        return (
            <>
               
            <tr>

                <th scope="row">
                    <label>Username</label> : <label>{data.user.user.first_name}</label>
                    <br/>
                    <label> اسم المستخدم </label> : <label>{data.user.ar_name}</label> 
                    <br/>
                    Email : {data.user.user.email?data.user.user.email:'No email'}
                    
                    
                        
                </th>
                <td>
                    <label >
                     {date.toDateString()}
                    </label>
                    <br/>
                    <label >
                    {Difference_In_Days==0?
                    <>
                    <label>Expired today</label>
                    </>
                    
                    :
                    <>
                    {Difference_In_Days<0?
                    <>
                    <label className="label text-green">Expire after {Math.abs(Difference_In_Days)} day</label>
                    
                    </>
                    :
                    <>
                    <label className="label text-red">Expired {Math.abs(Difference_In_Days)} day ago</label>
                    </>
                    }
                    </>
                    }
                    </label>
                </td>

                <td>
                    {data.user.user_type=='O'?
                    'Outsider'
                    :
                    "Tenant"
                    }

                </td>
                <td>{data.user.mobile}</td>
                
            </tr>
            </>
        )
    }
}


export default class componentName extends Component {
    constructor(){
        super()
        this.state={
            data:[],
            next:null,
            prev:null,

            loading:true,
            filtermodal:false,

            filter:null,

            keyword:"ex_soon",
            days:30,
        }
    }
    loading=(args)=>{
        this.setState({
            loading:args
        })
    }

    componentDidMount(){
        this.loading(true)

        this.fetchAllUsers()
    }

    next=()=>{
        this.loading(true)
        axios.get(
            this.state.next.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
    
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false
          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }
    
    
    prev=()=>{
        this.loading(true)
        let prev = this.state.prev;
        prev = prev.replace(/^http:\/\//i, 'https://');
        
        axios.get(
          prev,
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false
          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchAllUsers(){

        axios.get(
            Base.url + 'Agriments/?keyword='+this.state.keyword+"&day_count="+this.state.days,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading:false
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    makefilter=(keyword,days)=>{
        this.setState({
            keyword:keyword,
            days:days,
            filter:"enabled",
        },()=>this.fetchAllUsers())
    }
    readAll=()=>{
        this.setState({
            keyword:"all",
            days:"",
            filter:null
        },()=>{
            this.fetchAllUsers()
        })
    }
    render() {

        

        return (
            <div>
               

                {/* <NotificationContainer/> */}
                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Users" />

                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                        <div className="input-group input-group-alternative mb-3">
                                            
                                            {/* <input name="search" onKeyPress={this.handleKeyPress} value={this.state.search} onChange={this.onChange} className="form-control " placeholder="search user" type="text" /> */}
                                            {/* <button type="button" className="btn btn-sm btn-white " onClick={this.searchUser}><i className="fa fa-search" aria-hidden="true"></i></button> */}
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-6">

                                    </div>
                                    <div className="col-xl-3 col-lg-6">

                                    </div>
                                    <div className="col-xl-3 col-lg-6">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        {/* Table */}
                        
                        <div className="row">
                            <div className="col">
                                <div className="card shadow">
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }} className="card-header border-0">
                                        <div style={{ flex: 1, height: '100%' }}>

                                        <h3 className="mb-0">
                                            {this.state.filter&&<button className="btn btn-sm bg-translucent-secondary" onClick={this.readAll}>clear filter</button>} 
                                            Users 
                                        </h3>

                                            </div>
                                        {this.state.loading?"":
                                        <div style={{ height: '100%', flex: 1, justifyContent: 'center', display: 'flex', flexDirection: 'row' }}>
                                            <style dangerouslySetInnerHTML={{ __html: "\n                        .test1:hover{\n                          background-color: rgb(241, 241, 241);\n                          /* box-shadow: 0px 1px 2px 0px grey; */\n                        }\n                      " }} />
                                            {/* <button className="btn btn-light" onClick={()=>this.setState({filtermodal:true})}>Filter</button> */}
                                            
                                            <FilterModal
                                                    show={this.state.filtermodal}
                                                    makefilter={this.makefilter}
                                                    onHide={() => this.setState({ filtermodal: false })}
                                                />
                                            {/* <div className="test1" style={{ boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', flex: 1, justifyContent: 'center', borderBottomRightRadius: 10, borderTopRightRadius: 10,backgroundColor:this.state.outsider?'#6072E4':'white',color:this.state.outsider?'white':'black' }} onClick={this.fetchOutsiders}>Outsider</div> */}
                                        </div>
    }
                                        <div style={{ height: '100%', flex: 1, justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
                                            {/* <button type="button" className="btn btn-sucess btn-6x" data-target="#myModal" onClick={this.setStatus} >+ New User</button> */}
                                            {this.state.prev==null?<button disabled={true} className="btn btn-sm btn-primary">Prev</button>:<button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                                            {this.state.next==null?<button disabled={true} className="btn btn-sm btn-primary">Next</button>:<button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                                        </div>
                                    </div>
                                    {this.state.loading?<WaveLoading/>:
                                    <div className="table-responsive">
                                        <table className="table align-items-center table-flush">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">User (En/Ar)</th>
                                                    {/* <th scope="col">Username</th> */}
                                                    {/* <th scope="col">Email</th> */}
                                                    <th scope="col">Expire date</th>
                                                    <th scope="col">Type</th>
                                                    <th scope="col">Mobile</th>
                                                    {/* <th scope="col">Action</th> */}

                                                </tr>
                                            </thead>
                                            <tbody>

                                                {this.state.data.map((data,index)=> 
                                                <Items 
                                                Refresh={this.fetchAllUsers}
                                                ManageUsers={this.manageUsers} 
                                                key={index} 
                                                data={data} 
                                                />
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
    }
                                </div>
                            </div>
                        </div>
                    {/* Footer */}
                    <Footer />
                    </div>
                </div>
            </div>

        );
    }
}
